import { render, staticRenderFns } from "./TeamProfileSettings.vue?vue&type=template&id=69adeed7&"
import script from "./TeamProfileSettings.vue?vue&type=script&lang=js&"
export * from "./TeamProfileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports